module.exports = __webpack_public_path__ + "BannerNavidad2024_region.2595a93e9c544121965867958e5f720f.png";